import React from "react";
import {
  ShieldCheck,
  Search,
  Anchor,
  Layers,
  Droplet,
  Activity,
  ArrowRight,
} from "lucide-react";

export default function DetailedServices() {
  const services = [
    {
      title: "Tanker Vetting",
      description:
        "Independent evaluation aligned to OCIMF, SIRE & TMSA expectations.",
      bullets: ["Pre-inspection readiness", "Gap closure actions"],
      icon: <ShieldCheck size={24} />,
    },
    {
      title: "Survey & Investigation",
      description:
        "On-site inspections, casualty investigations, loss assessment, and reporting.",
      bullets: ["Root-cause analysis", "Clear, defensible reports"],
      icon: <Search size={24} />,
    },
    {
      title: "Dry Bulk Vetting",
      description:
        "End-to-end risk assessment for vessels & terminals in the dry bulk chain.",
      bullets: ["RightShip preparation", "Terminal compliance checks"],
      icon: <Anchor size={24} />,
    },
    {
      title: "Cargo Superintendency",
      description:
        "Supervision throughout loading/discharge to protect cargo quality and interests.",
      bullets: [
        "Quantity dispute mitigation",
        "Loss control oversight",
        "Vessel loading/Unloading in accordance with the approved Loading Manual and within all permissible stress and stability limits.",
      ],
      icon: <Layers size={24} />,
    },
    {
      title: "Underwater Surveys",
      description:
        "UWILD, hull & propeller assessment with certified divers & ROV partners.",
      bullets: ["Class-approved inspections", "Fouling assessments","Fouling assessments",],
      icon: <Droplet size={24} />,
    },
    // {
    //   title: "Project & Risk Management",
    //   description: "Structured hazard identification and mitigation across complex marine projects.",
    //   bullets: ["Risk register development", "Operational safety planning"],
    //   icon: <Activity size={24} />
    // }
  ];

  return (
    <section id="core-services" className="py-24 bg-[#F9F8F3]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-16">
          <span className="text-xs font-bold text-[#87412A] uppercase tracking-widest block mb-2">
            Expertise
          </span>
          <h2 className="text-4xl font-bold text-[#1E4363] font-serif">
            Core Services
          </h2>
          <p className="text-[#2C3539]/80 mt-4 max-w-2xl text-lg">
            Targeted expertise designed to protect people, assets, cargo, and
            corporate reputation across the value chain.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((item, index) => (
            <div
              key={index}
              className="bg-white p-8 border border-gray-200 rounded-sm hover:shadow-xl transition-all duration-300 flex flex-col justify-between"
            >
              <div>
                <div className="text-[#1E4363] mb-6 inline-block p-3 bg-[#1E4363]/5 rounded-sm">
                  {item.icon}
                </div>
                <h3 className="text-xl font-bold text-[#1E4363] font-serif mb-3">
                  {item.title}
                </h3>
                <p className="text-[#2C3539]/70 text-sm mb-6 leading-relaxed">
                  {item.description}
                </p>

                <ul className="space-y-2 mb-8 border-t border-gray-100 pt-4">
                  {item.bullets.map((bullet, idx) => (
                    <li
                      key={idx}
                      className="text-xs font-semibold text-[#2C3539]/80 flex items-start gap-2"
                    >
                      <span className="w-1.5 h-1.5 bg-[#87412A] rounded-full shrink-0 mt-1"></span>
                      <span>{bullet}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <a
                href="/contact"
                className="text-xs font-bold uppercase tracking-wider text-[#1E4363] hover:text-[#87412A] flex items-center gap-2 mt-auto group transition-colors"
              >
                Inquire Service{" "}
                <ArrowRight
                  size={14}
                  className="transform group-hover:translate-x-1 transition-transform"
                />
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
